import styled from "@emotion/styled";

export const Header = styled.header`
    color: var(--formant-color-primary-silver);
    user-select: none;
    font-weight: 800;
    font-size: 0.625rem;
    letter-spacing: 1.1px;
    line-height: 1.8;
    text-transform: uppercase;
    padding: 0.375rem;
`;

Header.displayName = "Menu.Header";
